import './team-leaders.styles.scss';
import { Link } from 'react-router-dom';
import { positions } from '@/utils/positions';

// Per-game stats count for players in at least half the team's games; the
// 3-point percentage needs an attempt per team game (at least 3).
const CATEGORIES = [
    { key: 'pts', title: 'Points', unit: 'PPG', value: s => s.pts / s.gp },
    { key: 'reb', title: 'Rebounds', unit: 'RPG', value: s => (s.oreb + s.dreb) / s.gp },
    { key: 'ast', title: 'Assists', unit: 'APG', value: s => s.ast / s.gp },
    {
        key: 'tp', title: '3-point shooting', unit: '3P%', pct: true,
        value: s => s.tpm / s.tpa, qualifies: (s, games) => s.tpa >= Math.max(3, games),
    },
];

const SHOWN = 3;

// The team's leaders in a few categories: the leader's number big, and the
// top three on bars measured against the leader.
const TeamLeaders = ({ team, playerLink }) => {

    const players = Object.values(team.players);
    const games = team.teamStats?.gp ?? Math.max(0, ...players.map(p => p.season?.gp ?? 0));
    const played = players.filter(p => p.season?.gp > 0 && p.season.gp >= games / 2);
    const format = (c, v) => (c.pct ? `${(v * 100).toFixed(1)}%` : v.toFixed(1));

    const boards = CATEGORIES.map(c => ({
        ...c,
        top: played
            .filter(p => !c.qualifies || c.qualifies(p.season, games))
            .map(p => ({ p, v: c.value(p.season) }))
            .filter(r => Number.isFinite(r.v))
            .sort((a, b) => b.v - a.v)
            .slice(0, SHOWN),
    }));

    return (
        <div className='g-card team-leaders'>
            <h3>Team leaders</h3>
            {!games ? <p className='meta'>Leaders show up once the season starts.</p> :
                <div className='leader-grid'>
                    {boards.map(c => {
                        const [ first ] = c.top;
                        return (
                            <section key={c.key} className='leader-tile'>
                                <div className='leader-title'>{c.title}</div>
                                {!first ? <p className='meta'>No one qualifies yet.</p> : <>
                                    <div className='leader-big'>
                                        <span className='leader-value'>{format(c, first.v)}</span>
                                        <span className='leader-unit'>{c.unit}</span>
                                    </div>
                                    <Link to={playerLink(team.id, first.p.id)} className='leader-name'>
                                        {first.p.fName} {first.p.lName}
                                    </Link>
                                    <div className='leader-pos meta'>{positions[first.p.pos1 - 1].short}</div>
                                    <ol className='leader-bars'>
                                        {c.top.map((r, i) => (
                                            <li key={r.p.id} className={i === 0 ? 'first' : ''}>
                                                <span className='bar-name'>{r.p.lName}</span>
                                                <span className='bar-value'>{format(c, r.v)}</span>
                                                <span className='bar-track' aria-hidden='true'>
                                                    <span className='bar-fill' style={{ width: `${first.v ? r.v / first.v * 100 : 0}%` }} />
                                                </span>
                                            </li>
                                        ))}
                                    </ol>
                                </>}
                            </section>
                        )
                    })}
                </div>
            }
            <div className='leader-links'>
                <Link to='roster'>Full roster and stats</Link>
                <Link to='lineup'>Lineup</Link>
                <Link to='strategy'>Strategy</Link>
            </div>
        </div>
    )
}

export default TeamLeaders
